module.exports = __webpack_public_path__ + "public/static/img/img-section4-2.0b84ce1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-section4-2.svg
// module id = 2v9o
// module chunks = 1